import { useOnResolve } from '@morningtrain/react-filters'
import useOperation from '../hooks/use-operation'

export default function OnlyKeepOperationFilterConstraintsOnResolve () {
  const operation = useOperation()

  useOnResolve((constraints) => {
    return new Promise(resolve => {
      if (operation) {
        Object.keys(constraints).forEach(key => {
          if (!operation.hasFilter(key)) {
            delete constraints[key]
          }
        })
      }

      resolve(constraints)
    })
  }, [operation])

  return null
}
